// extracted by mini-css-extract-plugin
module.exports = {"twitterPost":"TwitterPost_twitterPost__lb7yU","skeletonsBox":"TwitterPost_skeletonsBox__2cb9P","hideTweet":"TwitterPost_hideTweet__37Xz4"};